import React, { useState, useEffect } from 'react';
import Fetch from '../../../../../core/util/core/Fetch';
import config from '../../../../config/config';
import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';
import { loadData } from '../Util/List/CustomList/loadData';
import { useDispatch, useSelector } from 'react-redux';

import { TabContent, TabPane, Nav, NavItem, NavLink, Col } from 'reactstrap';
import classnames from 'classnames';

import '../home/Home.css';
import { ServiceLetter } from './ServiceLetter/ServiceLetter';
import ServiceLetterProvider from './ServiceLetter/contexts/ServiceLetterContext';
import { OrganogramProvider } from './Organogram/contexts/OrganogramContext';
import Property from './Properties/Property';
import { ViewOnlyOrganogram } from './Organogram/ViewOrganogram';

const Organization = (props) => {
    const sessionSelector = useSelector((state) => {
        return state.core.session;
    });
    const friendly_url = sessionSelector.pdc_project_friendly_url;


    const dispatch = useDispatch();

   

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'validity_start',
                type: 'date',
                label: 'Período de',
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'validity_end',
                type: 'date',
                label: 'Período até',
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'vigency',
                type: 'select',
                label: 'Vigência',
                options: [
                    { label: 'Em Vigência', value: '1' },
                    { label: 'Fora de Vigência', value: '0' },
                    { label: 'Todos', value: null }
                ],
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 1
            }
        ]
    };

    const paths = {
        endpoint: config.endpoints.backend + 'portal/getallprincipals'
    };

    const list = {
        labelTitle: 'Dirigentes',
        icon: 'fa-sitemap',
        filter: {
            friendly_url
        },
        formFilters: filters,
        columns: [
            {
                name: 'name',
                label: 'Nome'
            },
            {
                name: 'role',
                label: 'Função'
            },
            {
                name: 'profession',
                label: 'Profissão'
            },
            {
                name: 'vigency',
                label: 'Vigência'
            }
        ],
        columnsButtons: [
            {
                buttons: [
                    {
                        label: 'Movimentações',
                        icon: 'fas fa-eye',
                        onClick: async (item) => {
                            props.setPreviousMenu({
                                title: 'Organização',
                                page: 'organizations'
                            });
                            props.setMenuClicked({
                                title: 'Movimentações',
                                page: 'movements'
                            });
                            dispatch({
                                type: 'UPDATE_SESSION',
                                key: 'pdc_principal_id_movements',
                                value: item.id
                            });
                        },
                        width: '10%'
                    }
                ]
            }
        ]
    };

    return (
        <div
            className="mt-3 mr-3"
            style={{
                marginLeft: '30px'
            }}
        >
            {props.showNav && (
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                                active: props.activeTab === 'principals'
                            })}
                            onClick={() => {
                                props.setActiveTab('principals');
                            }}
                        >
                            Grupo Gestor
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                                active:
                                    props.activeTab === 'organizationalchart'
                            })}
                            onClick={() => {
                                props.setActiveTab('organizationalchart');
                            }}
                        >
                            Organograma
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            style={{ cursor: 'pointer' }}
                            className={classnames({
                                active: props.activeTab === 'servicelatter'
                            })}
                            onClick={() => {
                                props.setActiveTab('servicelatter');
                            }}
                        >
                            Carta de Serviço
                        </NavLink>
                    </NavItem>
                    {props.hasProperties && (
                        <NavItem>
                            <NavLink
                                style={{ cursor: 'pointer' }}
                                className={classnames({
                                    active: props.activeTab === 'properties'
                                })}
                                onClick={() => {
                                    props.setActiveTab('properties');
                                }}
                            >
                                Patrimônio
                            </NavLink>
                        </NavItem>
                    )}
                </Nav>
            )}
            <TabContent activeTab={props.activeTab} className="bg-white">
                <TabPane tabId="principals">
                    <Col sm="12">
                        <CustomListContainer
                            canAdd={false}
                            labelTitle={list.labelTitle}
                            icon={list.icon}
                            content={
                                <CustomList list={{ ...list, ...paths }} />
                            }
                        />
                    </Col>
                </TabPane>
                <TabPane tabId="organizationalchart">
                    <OrganogramProvider >
                        <ViewOnlyOrganogram />
                    </OrganogramProvider>
                </TabPane>
                <TabPane tabId="servicelatter">
                    <Col sm="12" className="p-0">
                        <ServiceLetterProvider>
                            <ServiceLetter />
                        </ServiceLetterProvider>
                    </Col>
                </TabPane>
                {props.hasProperties && (
                    <TabPane tabId="properties">
                        <Col sm="12" className="p-0">
                            <Property />
                        </Col>
                    </TabPane>
                )}
            </TabContent>
        </div>
    );
};

export default Organization;
